// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Home_navLink__3b7iQ","whiteText":"Home_whiteText__2bWCp"};